// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33BqC","title":"styles_title__2sohu"};